import {
    IEditorElementCollection,
    IEditorImage,
    IEditorPage,
    IEditorThumb,
    IPage,
    IThumbDictionary,
    SF
} from './interfaces';

class EditorImage implements IEditorImage {

    private static idCount: number = 1;
    public edits: { rotation?: number; autocorrect?: boolean };
    public height: number;
    public id: number;
    public name: string;
    public pathPrefix: string;
    public thumbs: IThumbDictionary;
    public urlPrefix: string;
    public width: number;

    constructor(private img: HTMLImageElement, filename: string) {
        this.edits = {};
        this.id = EditorImage.idCount++;
        this.height = img.height;
        this.width = img.width;
        this.name = filename;
        this.pathPrefix = '';
        this.urlPrefix = '';
        this.thumbs = {
            full: {
                name: 'full',
                width: this.width,
                height: this.height
            }
        };
    }

    getThumb(thumb: string): IEditorThumb {
        return this.thumbs.full;
    }

    getUrl(thumbName: string, hasAutoCorrect?: boolean, hasAutoRedEye?: boolean): string {
        return this.img.src;
    }

}

export class RendererImage {
    private static editorImages: { [key: number]: EditorImage } = {};

    public static toPage(page: IPage, pageLabels?: string[], dynamicData?: any): IEditorPage {
        // @ts-ignore
        return SF.Util.Edits.toPage(page, pageLabels, dynamicData);
    }

    public static toCollection(pages: IEditorPage[], showingIndex?: number): IEditorElementCollection {
        return new SF.Model.ElementCollection(pages, showingIndex);
    }

    public static getEditorImageFromImage(img: HTMLImageElement, filename: string): IEditorImage {
        const editorImage = new EditorImage(img, filename);
        this.editorImages[editorImage.id] = editorImage;
        return editorImage;
    }

    public static removeEditorImage(imageId: number): void {
        delete this.editorImages[imageId];
    }

    public static getEditorImage(imageId: number): EditorImage {
        return this.editorImages[imageId];
    }

    public static clearAllImages(): void {
        this.editorImages = {};
    }
}
